import ReactDOM from 'react-dom/client';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { Provider } from 'react-redux';
import eruda from 'eruda';
///////////////////////////////////////////
import './polyfills';
import './globals.css';
import { ThemeProvider } from './theme-provider.tsx';
import App from './App.tsx';
import store from '@/core/redux/store';

export const telegramWebApp = window.Telegram.WebApp;

// Check if the Telegram WebApp object exists to prevent errors
if (telegramWebApp) {
	// Notify Telegram that the web app is ready
	telegramWebApp.ready();

	// Expand the web app to the full height of the screen
	telegramWebApp.expand();

	// Disable closes the app on swipe down
	telegramWebApp.isVerticalSwipesEnabled = false;

	// Set the header color
	telegramWebApp.setHeaderColor(process.env.VITE_APP_COLOR || '#00C2FF');

	if (
		process.env.VITE_ENV_APP === 'dev' ||
		process.env.VITE_ENV_APP === 'int'
	) {
		// Debugger in int
		eruda.init();
	}
} else {
	console.error('Telegram WebApp is not available');
}

ReactDOM.createRoot(document.getElementById('root')!).render(
	<TonConnectUIProvider manifestUrl="https://dojo-int.vottun.tech/manifest.json">
		<Provider store={store}>
			<ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
				<App />
			</ThemeProvider>
		</Provider>
	</TonConnectUIProvider>
);
